import { createAcquisition } from "@/api/acquisitions";
import { CustomField } from "@/Features/CustomFields/custom-fields.types";
import { db_timestamp } from "@/utils/date-format";
import { ImportBatchResult } from "../../_components/DataImport";
import { toDbDateBoxValue } from "../../_components/DataImport/utils";

interface ImportAcquisitionRecordsOptions {
  records: Record<string, unknown>[];
  case_id: number;
  customFields: CustomField[];
}

export async function importAcquisitionRecords({
  records,
  case_id,
  customFields,
}: ImportAcquisitionRecordsOptions): Promise<ImportBatchResult> {
  let successful = 0;
  let failed = 0;
  const errors: { row: number; message: string }[] = [];

  for (let i = 0; i < records.length; i++) {
    try {
      const record = { ...records[i] };

      record.case_id = case_id;

      if (record.storage_id) {
        record.storage_items = [record.storage_id];
        delete record.storage_id;
      }

      if (record.person_id) {
        record.contact_id = record.person_id;
        delete record.person_id;
      }

      if (record.acquire_date) {
        record.acquire_date = db_timestamp(record.acquire_date as string);
      }

      const customAttributes: {
        field_id: number;
        value: unknown;
      }[] = [];
      for (const cf of customFields) {
        const key = `custom_attribute_${cf.field_id}`;
        if (
          key in record &&
          record[key] !== null &&
          record[key] !== undefined
        ) {
          customAttributes.push({
            field_id: cf.field_id,
            value:
              cf.editor_type === "dateBox"
                ? toDbDateBoxValue(record[key])
                : record[key],
          });
        }
        delete record[key];
      }
      if (customAttributes.length > 0) {
        record.custom_attributes = customAttributes;
      }

      await createAcquisition(record);
      successful++;
    } catch (err) {
      failed++;
      errors.push({
        row: i,
        message:
          err instanceof Error ? err.message : "Failed to create acquisition",
      });
    }
  }

  return { successful, failed, errors };
}
